import * as Sentry from "@sentry/react";
import { useBackfillStore } from "../../store/backfillsStore";

// "connection" (auth-flow hint) and "datagrid-preferences" (cosmetic) are intentionally not purged.
const DATA_STORAGE_KEYS = ["urlName", "selectedExports"] as const;

// The Apollo cache is cleared separately by GraphQLShell, which owns the client instance.
export const clearClientData = (): void => {
  DATA_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
  useBackfillStore.getState().resetStore();
  Sentry.setUser(null);
};
